import type { ComponentType } from 'react';
import { AssistantSection } from './assistant/index.tsx';
import { ConversationsSection } from './conversations/index.tsx';
import { EvaluationsSection } from './evaluations/index.tsx';
import { OverviewSection } from './overview/index.tsx';
import { SettingsSection } from './settings/index.tsx';
import { UsageSection } from './usage/index.tsx';

export interface Section {
  readonly id: string;
  readonly title: string;
  readonly Component: ComponentType;
}

export const SECTIONS: readonly [Section, ...Section[]] = [
  { id: 'overview', title: 'Overview', Component: OverviewSection },
  { id: 'conversations', title: 'Conversations', Component: ConversationsSection },
  { id: 'evaluations', title: 'Evaluations', Component: EvaluationsSection },
  { id: 'assistant', title: 'Assistant', Component: AssistantSection },
  { id: 'usage', title: 'Usage', Component: UsageSection },
  { id: 'settings', title: 'Settings', Component: SettingsSection },
];

export function findSection(id: string): Section {
  return SECTIONS.find((section) => section.id === id) ?? SECTIONS[0];
}
